import { createAction } from 'redux-actions'

import {
  ROUTE_DASHBOARD,
  ROUTE_NEWSLETTERS_EDIT,
  ROUTE_NEWSLETTERS_NEW,
  ROUTE_COMPONENTS,
  ROUTE_COMPONENTS_NEW,
  ROUTE_COMPONENTS_EDIT,
  ROUTE_PRODUCTS,
  ROUTE_PRODUCTS_NEW,
  ROUTE_PRODUCTS_EDIT,
  ROUTE_USERS,
  ROUTE_USERS_NEW,
  ROUTE_USERS_EDIT,
  ROUTE_CONTACTS,
  ROUTE_CONTACTS_NEW,
  ROUTE_CONTACTS_EDIT,
  ROUTE_LOGIN,
  ROUTE_RESET,
  ROUTE_REGISTER,
} from '@/state/types/routes'

// ROUTING
export const goToPage = (type, query, payload) => ({
  type,
  ...(query && { meta: query }),
  ...(payload && { payload }),
})

export const routeDashboard = createAction(ROUTE_DASHBOARD)
export const routeNewslettersNew = createAction(ROUTE_NEWSLETTERS_NEW)
export const routeNewslettersEdit = id => ({
  type: ROUTE_NEWSLETTERS_EDIT,
  payload: { id },
})

export const routeComponents = createAction(ROUTE_COMPONENTS)
export const routeComponentsNew = createAction(ROUTE_COMPONENTS_NEW)
export const routeComponentsEdit = id => ({
  type: ROUTE_COMPONENTS_EDIT,
  payload: { id },
})

export const routeProducts = createAction(ROUTE_PRODUCTS)
export const routeProductsNew = createAction(ROUTE_PRODUCTS_NEW)
export const routeProductsEdit = id => ({
  type: ROUTE_PRODUCTS_EDIT,
  payload: { id },
})

// export const routeTeam = createAction(ROUTE_TEAM)
export const routeUsers = createAction(ROUTE_USERS)
export const routeUsersNew = createAction(ROUTE_USERS_NEW)
export const routeUsersEdit = id => ({
  type: ROUTE_USERS_EDIT,
  payload: { id },
})

export const routeContacts = createAction(ROUTE_CONTACTS)
export const routeContactsNew = createAction(ROUTE_CONTACTS_NEW)
export const routeContactsEdit = id => ({
  type: ROUTE_CONTACTS_EDIT,
  payload: { id },
})

export const routeLogin = createAction(ROUTE_LOGIN)
export const routeReset = createAction(ROUTE_RESET)
export const routeRegister = createAction(ROUTE_REGISTER)



// WEBPACK FOOTER //
// ./state/actions/routes.js